import { orchestrator } from 'satcheljs';
import { loadSubsriptionsCache } from '../actions/publicActions';
import getUserBrandsSubscriptionsService from '../services/getBrandsSubscriptionsService';

orchestrator(loadSubsriptionsCache, actionMessage => {
    // Calling the service by itself will make the cache to be loaded or updated
    getUserBrandsSubscriptionsService(true /* dont load brands info */);
});
